/**************************************************
###################################################
** Product page: Updates on variant change
***************************************************
**
** Variant: DOM Ready
** Variant: Find variants  
** Variant: Color name update
** Variant: SKU update
** Variant: Auto-select size when needed
**
***************************************************
###################################################
**************************************************/

/************************************************
 **** Variant: DOM Ready
 ************************************************/

;(function () {
  "use strict"

  // Format a color name in Title Case (e.g. "DARK BLUE" -> "Dark Blue")
  function toTitleCase(value) {
    return value
      .toLowerCase()
      .split(" ")
      .map(word => (word ? word.charAt(0).toUpperCase() + word.slice(1) : word))
      .join(" ")
  }

  // SKU Update Function
  function updateCurrentVariantSKU(variant) {
    const skuElement = document.querySelector(".page-product .currentSKU span")
    if (skuElement && variant?.sku) {
      skuElement.textContent = variant.sku
    }
  }

  // Helper to get active variant from hidden input
  function getActiveVariant() {
    const variantSelector = document.querySelector('.page-product input[name="id"]')
    if (!variantSelector || !window.meta?.product?.variants) return null
    return window.meta.product.variants.find(v => v.id == variantSelector.value)
  }

  // Uncheck disabled sizes, select first available (ignore disabled if color is disabled)
  function ensureSizeSelected(variantSelects) {
    if (!variantSelects) return

    const sizeInputs = variantSelects.querySelectorAll('input[type="radio"][name="Size"]')
    if (!sizeInputs.length) return

    // Check if product has Color options at all
    const hasColorInputs = variantSelects.querySelector('input[type="radio"][name="Color"]')

    const colorInput = variantSelects.querySelector('input[type="radio"][name="Color"]:checked')
    const isColorDisabled = colorInput?.classList.contains("disabled") || colorInput?.disabled

    // Uncheck disabled sizes (unless color is disabled OR no color inputs exist)
    let hasValidSize = false
    Array.from(sizeInputs).forEach(input => {
      if (input.checked && !input.classList.contains("disabled") && !input.disabled) {
        hasValidSize = true
      }
      if (
        input.checked &&
        (input.classList.contains("disabled") || input.disabled) &&
        !isColorDisabled &&
        hasColorInputs // Only uncheck if Color exists AND isn't disabled
      ) {
        input.checked = false
      }
    })

    if (hasValidSize) return

    // Select first valid visible size
    const firstValid = Array.from(sizeInputs).find(input => {
      const wrapper = input.closest(".size-option")
      const isVisible = !wrapper || wrapper.style.display !== "none"
      const isValid =
        !hasColorInputs || isColorDisabled
          ? true
          : !input.classList.contains("disabled") && !input.disabled
      return isVisible && isValid
    })

    if (firstValid) {
      firstValid.checked = true
      firstValid.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  function initColorSelector() {
    const variantSelectsList = document.querySelectorAll(".page-product variant-selects")
    if (!variantSelectsList.length) {
      // If DOM is not ready yet, retry
      requestAnimationFrame(initColorSelector)
      return
    }

    /************************************************
     **** Variant: Find variants & SKU init
     ************************************************/

    variantSelectsList.forEach(variantSelects => {
      const sectionId = variantSelects.dataset.section
      if (!sectionId) return

      // Initial SKU update
      const initialVariant = getActiveVariant()
      if (initialVariant?.sku) {
        updateCurrentVariantSKU(initialVariant)
      }

      // Only require colorSelectedEl if there are Color inputs
      const colorSelectedEl = document.getElementById(`ColorSelected-${sectionId}`)

      const colorInputs = variantSelects.querySelectorAll('input[type="radio"][name="Color"]')
      const sizeInputs = variantSelects.querySelectorAll('input[type="radio"][name="Size"]')

      if (!colorInputs.length && !sizeInputs.length) return

      const colorLabelEl =
        colorSelectedEl?.querySelector(".color-selected__label") || colorSelectedEl || null

      /************************************************
       **** Variant: Color name update
       ************************************************/
      const updateColorLabel = input => {
        // Guard when no color label exists
        if (!input || !colorLabelEl) return
        const value = input.value || input.getAttribute("data-color-name") || ""
        colorLabelEl.textContent = toTitleCase(value)
      }

      // Initial sync for color
      const initiallyCheckedColor = Array.from(colorInputs).find(input => input.checked)
      if (initiallyCheckedColor) updateColorLabel(initiallyCheckedColor)

      // On first load, ensure we have a valid size
      ensureSizeSelected(variantSelects)

      /************************************************
       **** Variant: Color inputs event listeners
       ************************************************/

      colorInputs.forEach(input => {
        input.addEventListener("change", event => {
          if (event.target.checked) {
            updateColorLabel(event.target)

            // Update SKU on color change
            const variant = getActiveVariant()
            if (variant?.sku) {
              updateCurrentVariantSKU(variant)
            }

            // after color change, ensure valid size is selected
            setTimeout(() => {
              ensureSizeSelected(variantSelects)
            }, 100)
          }
        })
      })

      /************************************************
       **** Variant: Size inputs event listeners
       ************************************************/

      sizeInputs.forEach(input => {
        input.addEventListener("change", event => {
          if (event.target.checked) {
            // Update SKU on size change
            const variant = getActiveVariant()
            if (variant?.sku) {
              updateCurrentVariantSKU(variant)
            }
          }
        })
      })

      // Watch hidden variant selector input for changes
      const variantSelector = document.querySelector('.page-product input[name="id"]')
      if (variantSelector) {
        variantSelector.addEventListener("change", function (event) {
          const selectedVariantId = event.target.value
          const variant = window.meta.product.variants.find(v => v.id == selectedVariantId)
          if (variant?.sku) {
            updateCurrentVariantSKU(variant)
          }
        })
      }
    })
  }

  // Start when everything is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initColorSelector)
  } else {
    requestAnimationFrame(initColorSelector)
  }
})()
